import { render, staticRenderFns } from "./DeleteIdTag.vue?vue&type=template&id=2f540fba&"
import script from "./DeleteIdTag.vue?vue&type=script&lang=ts&"
export * from "./DeleteIdTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports